// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9pE-h","left":"styles_left__3eVvG"};